module.exports = __webpack_public_path__ + "img/data_import.e3944d30.svg";